import { VISIBLE_TIMEOUT } from '~/constants'

interface IProps {
  defaultValue: boolean
}

export const useHiddenToScroll = ({ defaultValue = true }: IProps) => {
  let scrollTimeout: ReturnType<typeof setTimeout> | null = null
  let lastScrollY = 0
  const isVisible = ref(defaultValue)

  const handleVisibleHeader = () => {
    const currentScrollY = window.scrollY

    isVisible.value = currentScrollY <= lastScrollY

    lastScrollY = currentScrollY

    if (scrollTimeout) {
      clearTimeout(scrollTimeout)
    }

    scrollTimeout = setTimeout(() => {
      isVisible.value = defaultValue
    }, VISIBLE_TIMEOUT)
  }

  onMounted(() => {
    window.addEventListener('scroll', handleVisibleHeader)
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', handleVisibleHeader)
  })
  return {
    isVisible,
  }
}
